const LanguageActionTypes = {
    LANG_CHANGE_START: 'LANG_CHANGE_START',
    LANG_CHANGE_SUCCESS: 'LANG_CHANGE_SUCCESS',
    LANG_CHANGE_ERROR: 'LANG_CHANGE_ERROR'
};

export default LanguageActionTypes;